import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {DealExternalLinks} from "@irati/types"
import tickImage from "@irati/ui/images/tick-green-circle.png"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {perksGOTracking} from "@irati-tracking/perksgo"
import Flex from "@irati/ui/src/Flex"
import {Body, H3} from "@irati/ui/src/Typography"
import Link, {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"

import {
  TickImage,
  PerksGOImage
} from "./styled"


interface Props extends InjectIntl {
  isPerksGoRetailDeal: boolean,
  dealExternalLinks: DealExternalLinks
}

class HasCardBlock extends PureComponent<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  render() {
    const {apps} = this.context
    const {formatMessage, isPerksGoRetailDeal, dealExternalLinks} = this.props

    return (
      <Flex direction="column" alignItems="center">
        <H3 marginBottom={1}>
          <FormattedMessage id="perksgo.perksGoImportantInfo.title" />
        </H3>
        <Flex>
          <TickImage
            src={tickImage}
            alt={formatMessage({id: "perksgo.perksGoImportantInfo.greenTickAlt"})} />
          <Body small marginBottom="0">
            <FormattedMessage id="perksgo.perksGoImportantInfo.hasCardBlock.title" />
          </Body>
        </Flex>
        <PerksGOImage icon="perksGO" size={80} />
        <Body small textAlign="center" margin="0 auto" maxWidth="280px">
          <FormattedMessage id="perksgo.perksGoImportantInfo.hasCardBlock.text" />
        </Body>
        {!isPerksGoRetailDeal && (
          <>
            <ButtonRouterLink
              full
              app={apps.WALLET}
              to="/"
              onClick={perksGOTracking.goToWalletCTA}
              marginTop={2}>
              <FormattedMessage id="perksgo.perksGoImportantInfo.hasCardBlock.walletButton" />
            </ButtonRouterLink>
            <ButtonRouterLink
              full
              app={apps.ACCOUNT}
              to="/settings/linkedcards"
              onClick={perksGOTracking.manageLinkedCardsCTA}
              marginTop={2}>
              <FormattedMessage id="perksgo.perksGoImportantInfo.hasCardBlock.linkedCardsButton" />
            </ButtonRouterLink>
          </>
        )}
        {isPerksGoRetailDeal && (
          <>
            <ButtonLink
              primary
              full
              href={dealExternalLinks?.web}
              target="_blank"
              margin={[3, 0, 2]}>
              <FormattedMessage id="perksgo.perksGoImportantInfo.hasCardBlock.visitOnlineStore" />
            </ButtonLink>
            <Link
              href={formatMessage({id: "perksgo.perksGoImportantInfo.hasCardBlock.refundPolicyLink"})}
              target="_blank">
              <FormattedMessage id="perksgo.perksGoImportantInfo.hasCardBlock.refundPolicy" />
            </Link>
          </>
        )}
      </Flex>
    )
  }
}

export default injectIntl(HasCardBlock)
